export default {
  landing: {
    title: "We will find you the best price for your solar project, for free!",
    titleBefore: "We will find you ",
    titleHighlight: "the best price",
    titleAfter: " for your solar project, for free!",
    shareQuote:
      "Share the amount of your quote. With 1,200 local RGE craftsmen without subcontracting, we could do better.",
    getStarted: "Get started",
    uploadInstead: "Upload your quote file instead",
    stepLabel: "Step",
    step1: "We define the specifications",
    step2: "You receive controlled offers",
    step3: "Choose your price!",
    step4: "Town planning approach offered at the town hall",
  },
  header: "Get best price / Quote info",
  upload: {
    title: "Your quote for a photovoltaic installation",
    automatic: "Automatic",
    manual: "Manual",
    uploadLabel: "Upload your quote file",
    uploadHint: "PDF, JPEG, PNG. Up to 10 MB.",
    next: "Next",
  },
  final: {
    thanks: "Thanks, we will contact you again soon!",
    wantToKnowMore: "Want to know more about what we do?",
    learnMoreDescription:
      "We specialize in optimizing every aspect of the solar installation ecosystem to maximize efficiency and sustainability.",
    learnMore: "Learn more about us",
  },
  projectType: {
    title: "Project type",
    solarPanels: "Solar panels",
    battery: "Battery",
    evCharger: "EV Charger",
    heatPump: "Heat pump",
    next: "Next",
  },
  quoteAmount: {
    title: "What quote did you get for installation?",
    label: "Total amount for materials and installation",
    ht: "HT",
    ttc: "TTC",
    excludingTax: "Excluding taxes, HT",
    includingTax: "Including all taxes, TTC",
    next: "Next",
  },
  timeline: {
    title: "When is your system being installed?",
    within1Month: "Within 1 month",
    within3Months: "Within 3 months",
    within6Months: "Within 6 months",
    moreThan6Months: "More than 6 months later",
    hint: "Provide an approximation if necessary.",
    next: "Next",
  },
  status: {
    title: "Next step",
    description:
      "Help us understand if it's not too late for you to benefit from a better price.",
    installationDone: "None, my installation is already done",
    signedQuote: "I want advice, I signed my quote",
    wantBetterPrice: "I want a better price, I haven't chosen a quote yet",
    noQuote: "I want to find a local RGE craftsman, I don't have a quote",
    next: "Next",
  },
  additionalInfo: {
    title: "One last step",
    label: "Any additional info we must know",
    placeholder: "Lorem ipsum",
    next: "Next",
  },
  contact: {
    title: "Your contact details",
    intro: "We are an orchestrator of solar projects with more than 200 MW of powered sites.",
    learnMore: "Learn more about us >",
    next: "Next",
  },
  gotQuestions: "Got questions?",
  bookCall: "Book a call",
}
